var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAthumLogoMinified = function SvgAthumLogoMinified(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6427 0.917357V13.8879C17.6427 14.4004 17.2146 14.8074 16.7012 14.8074H14.8182C14.2943 14.8074 13.8767 14.3898 13.8767 13.8879V5.07614C13.8767 4.41813 13.1918 3.96796 12.5712 4.21891L0.588091 9.02708C0.233704 9.17362 0 9.5079 0 9.88431V31.0805C0 31.5929 0.428138 32 0.941521 32H12.9236C13.4476 32 13.8652 31.5814 13.8652 31.0805V22.9804C13.8652 22.4679 14.2933 22.0609 14.8067 22.0609H16.6897C17.2136 22.0609 17.6313 22.4794 17.6313 22.9804V31.0805C17.6313 31.5929 18.0594 32 18.5728 32H30.5549C31.0788 32 31.4964 31.5814 31.4964 31.0805V5.73511C31.4964 5.35869 31.2608 5.02442 30.9083 4.87787L18.9262 0.0706585C18.3276 -0.180286 17.6427 0.268924 17.6427 0.917357Z",
    fill: "#3ECFAF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAthumLogoMinified, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/athum-logo-minified.2dce4017.svg";
export { ForwardRef as ReactComponent };